import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController, PopoverController } from '@ionic/angular';
import { AppNavigationStateService } from 'src/app/services/startup/app-navigation-state.service';

@Component({
	selector: 'app-return-bar',
	templateUrl: './return-bar.component.html',
	styleUrls: ['./return-bar.component.scss'],
})
export class ReturnBarComponent implements OnInit {
	@Input() title: string = "Regresar";
	@Input() pageToReturn: string = "home";
	@Input() type: string = "page";

	@Output() resendMessageEvent = new EventEmitter<any>();
	constructor(
		private modalController: ModalController,
		private navCtrl: NavController,
		private popOvercontroller: PopoverController,
		private router: Router,
		private navigationState: AppNavigationStateService,
	) { }

	ngOnInit() { }

	closeModal() {
		this.modalController.dismiss();
	}

	return_click() {
		if (this.pageToReturn === '/home/ecosystem-page') {
			this.navCtrl.navigateRoot('/home/ecosystem-page');
			return;
		}
		this.navCtrl.navigateBack(this.pageToReturn);
	}

	async pop_page() {
		const fallback = this.navigationState.backFallbackForCurrentRoute(this.router.url);
		const didNavigate = await this.router.navigateByUrl(fallback, { replaceUrl: true });
		if (!didNavigate) {
			await this.router.navigateByUrl('/home/ecosystem-page', { replaceUrl: true });
		}
	}

	closePopOver(){
		this.popOvercontroller.dismiss();
	}

	resendMessage(){
		this.resendMessageEvent.emit(true);
	}
}
